import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type HomeMode = "smart" | "expert";

export interface SettingsState {
  mode: HomeMode;
  language: string;
  currency: string;
  nationality: string;
  suppliers: string[];
}

const initialState: SettingsState = {
  mode: "expert",
  language: import.meta.env.VITE_DEFAULT_LANGUAGE ?? "it",
  currency: import.meta.env.VITE_DEFAULT_CURRENCY ?? "EUR",
  nationality: import.meta.env.VITE_DEFAULT_NATIONALITY ?? "IT",
  suppliers: [],
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setMode(state, action: PayloadAction<HomeMode>) {
      state.mode = action.payload;
    },
    setLanguage(state, action: PayloadAction<string>) {
      state.language = action.payload;
    },
    setCurrency(state, action: PayloadAction<string>) {
      state.currency = action.payload;
    },
    setNationality(state, action: PayloadAction<string>) {
      state.nationality = action.payload;
    },
    setSuppliers(state, action: PayloadAction<string[]>) {
      state.suppliers = action.payload;
    },
    toggleSupplier(state, action: PayloadAction<string>) {
      const code = action.payload;
      const idx = state.suppliers.indexOf(code);
      if (idx >= 0) state.suppliers.splice(idx, 1);
      else state.suppliers.push(code);
    },
  },
});

export const {
  setMode,
  setLanguage,
  setCurrency,
  setNationality,
  setSuppliers,
  toggleSupplier,
} = settingsSlice.actions;

export default settingsSlice.reducer;
